import { CONCERN_DIMENSION, FACET_BY_ID, STYLE_DIMENSION, APPROACH_BY_ID, SCHEDULE_BY_ID, BUDGET_OPTIONS } from '../data/taxonomy.js';
import { INTAKE_INSURANCE_OPTIONS, FLEXIBLE_INSURANCE, intakeInsurance } from './clinicianEligibility.js';
export const INITIAL_CLIENT = {
  concerns: [], selectedFacets: [], priority: {}, stylePref: [], approachPref: [],
  insurance: '', budget: '', schedule: [], format: '', therapyLanguage: '', openToSupervised: true, sooner: false,
};
export function normalizeClient(input = {}) {
  const value = input && typeof input === 'object' ? input : {};
  const list = (key, allowed) => Array.isArray(value[key]) ? [...new Set(value[key].filter((v) => allowed.includes(v)))] : [];
  const selectedFacets = list('selectedFacets', Object.keys(FACET_BY_ID));
  return {
    concerns: list('concerns', CONCERN_DIMENSION.options), selectedFacets,
    priority: Object.fromEntries(selectedFacets.filter((id) => value.priority?.[id] === true).map((id) => [id, true])),
    stylePref: list('stylePref', STYLE_DIMENSION.options), approachPref: list('approachPref', Object.keys(APPROACH_BY_ID)),
    schedule: list('schedule', Object.keys(SCHEDULE_BY_ID)),
    insurance: (INTAKE_INSURANCE_OPTIONS.includes(value.insurance) || FLEXIBLE_INSURANCE.includes(value.insurance) || intakeInsurance(value.insurance)) ? value.insurance : '',
    budget: BUDGET_OPTIONS.some((b) => b.value === value.budget) ? value.budget : '',
    format: ['individual', 'couples'].includes(value.format) ? value.format : '',
    therapyLanguage: value.therapyLanguage === 'Spanish' ? 'Spanish' : '',
    openToSupervised: value.openToSupervised !== false, sooner: value.sooner === true,
  };
}
export function normalizeMatchingDraft(value) {
  return { step: Number.isInteger(value?.step) && value.step >= 0 && value.step <= 3 ? value.step : 0,
    client: normalizeClient(value?.client) };
}
